// removed by extract-text-webpack-plugin
module.exports = {"tabsContainer":"tabsContainer-25VP2 tabsContainer-cJOxE","tab":"tab-3I9zN tab-2GJzS","tabActive":"tabActive-1Op2U tabActive-3rQTb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/routes/myRoutes/_myRoutesHeader.css
// module id = 1263
// module chunks = 1